import request from '@/utils/request';
//活动分页
export function queryEventPage(values) {
  return request('/activity/queryEventPage', {
    method: 'POST',
    data: values,
  });
}
//删除活动
export function activityDelete(values) {
  return request('/activity/deleteEvent', {
    method: 'POST',
    data: values,
  });
}
